module.exports = __webpack_public_path__ + "img/REP-USD.c97774f7.png";